<template>
  <a-card>
    <a-tabs v-model="tabActive">
      <a-tab-pane :key="1" tab="普通内容">
        <GeneralContent />
      </a-tab-pane>
      <a-tab-pane v-if="isExperience" :key="2" tab="体验内容">
        <ExperienceContent />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import GeneralContent from './general/GeneralContent'
import ExperienceContent from './experienceContent/index.vue'
import { CourseResource } from '../../../../utils/http'

export default {
  name: 'ContentList',
  components: { GeneralContent, ExperienceContent },
  data() {
    return {
      tabActive: 1,
      isExperience: false,
    }
  },
  created() {
    this.checkExperienceContent()
  },
  methods: {
    async checkExperienceContent() {
      const seriesInfo = this.$store.getters['course/getSeriesInfo']()
      const { data } = await CourseResource.checkSeriesExperience({ courseSeriesId: seriesInfo.id })
      this.isExperience = data
    },
  },
}
</script>

<style scoped></style>
